import * as React from 'react';
import { connect } from 'react-redux';

import CampaignOverview from '../campaign-overview/CampaignOverview';

import type { Campaign, CampaignPageType } from 'types';

type OwnProps = {
  pageType: CampaignPageType
};

type StateProps = {
  campaign: Campaign
};

type Props = OwnProps & StateProps;

class CampaignDashboardInfo extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { campaign, pageType } = this.props;
    return (
      <CampaignOverview
        campaign={campaign}
        pageType={pageType}
      />
    );
  }
}

const mapStateToProps = ({ campaignBrief }): StateProps => ({
  campaign: campaignBrief.brief
});

export default connect(mapStateToProps)(CampaignDashboardInfo);
